import React, { useState } from 'react';
import { X, Truck, UserCheck, Search } from 'lucide-react';

function DriverSelectionModal({ drivers, onSelect, onClose, selectedCount }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDriver, setSelectedDriver] = useState(null);

  const filteredDrivers = drivers.filter((driver) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      driver.name?.toLowerCase().includes(searchLower) ||
      driver.email?.toLowerCase().includes(searchLower) ||
      String(driver.id).includes(searchTerm)
    );
  });

  const handleSelectDriver = (driver) => {
    setSelectedDriver(driver);
  };

  const handleConfirm = () => {
    if (selectedDriver) {
      onSelect(selectedDriver.id);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-2 sm:p-4 font-montserrat" style={{ zIndex: 9999 }}>
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[calc(100dvh-1rem)] sm:max-h-[80dvh] min-h-0 overflow-hidden flex flex-col">
        {/* Header */}
        <div className="bg-[#B1336E] px-3 py-3 sm:px-6 sm:py-4 flex items-center justify-between gap-2 rounded-t-xl shrink-0">
          <div className="flex items-center gap-3">
            <UserCheck className="w-6 h-6 text-white" />
            <div>
              <h2 className="text-xl font-bold text-white">
                Asignar Conductor
              </h2>
              <p className="text-sm text-white/80">
                {selectedCount} punto(s) seleccionado(s)
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-[#B1336E]/80 rounded-lg transition-colors"
          >
            <X className="w-6 h-6 text-white" />
          </button>
        </div>

        {/* Search */}
        <div className="p-4 border-b border-slate-200">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400" />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Buscar conductor..."
              className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] text-sm"
            />
          </div>
        </div>

        {/* Drivers List */}
        <div className="min-h-0 flex-1 overflow-y-auto p-3 sm:p-4">
          {filteredDrivers.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12 text-center">
              <Truck className="w-16 h-16 text-slate-300 mb-4" />
              <p className="text-slate-600">
                No se encontraron conductores
              </p>
            </div>
          ) : (
            <div className="space-y-2">
              {filteredDrivers.map((driver) => {
                const isSelected = selectedDriver?.id === driver.id;
                
                return (
                  <button
                    key={driver.id}
                    onClick={() => handleSelectDriver(driver)}
                    className={`w-full text-left p-4 rounded-lg border-2 transition-all ${
                      isSelected
                        ? 'border-[#B1336E] bg-[#B1336E]/5'
                        : 'border-slate-200 hover:border-[#B1336E]/50 hover:bg-slate-50'
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <div
                        className={`w-12 h-12 rounded-full flex items-center justify-center ${
                          isSelected ? 'bg-[#B1336E]' : 'bg-[#E6B43C]'
                        }`}
                      >
                        <Truck className="w-6 h-6 text-white" />
                      </div>
                      
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-1">
                          <p className="font-bold text-slate-800">
                            {driver.name || `Conductor ${driver.id}`}
                          </p>
                          {isSelected && (
                            <div className="w-5 h-5 bg-[#B1336E] rounded-full flex items-center justify-center">
                              <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                              </svg>
                            </div>
                          )}
                        </div>
                        
                        {driver.email && (
                          <p className="text-sm text-slate-600">
                            {driver.email}
                          </p>
                        )}
                        
                        <div className="flex items-center gap-2 mt-1">
                          <span className="text-xs text-slate-500">
                            ID: {driver.id}
                          </span>
                          {driver.latitude && driver.longitude && (
                            <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded">
                              En línea
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="bg-slate-50 px-3 py-3 sm:px-6 sm:py-4 border-t border-slate-200 rounded-b-xl flex gap-2 sm:gap-3 shrink-0">
          <button
            onClick={onClose}
            className="flex-1 py-2 px-4 bg-white hover:bg-slate-100 text-slate-700 font-medium rounded-lg border border-slate-300 transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirm}
            disabled={!selectedDriver}
            className={`flex-1 py-2 px-4 font-medium rounded-lg transition-colors ${
              selectedDriver
                ? 'bg-[#B1336E] hover:bg-[#B1336E]/90 text-white'
                : 'bg-slate-300 text-slate-500 cursor-not-allowed'
            }`}
          >
            Asignar Conductor
          </button>
        </div>
      </div>
    </div>
  );
}

export default DriverSelectionModal;
